<h1 mat-dialog-title>SKU {{ data.ItemNumber }}</h1>
<div mat-dialog-content class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <mat-label>Item Number</mat-label>
      <input matInput [(ngModel)]="data.ItemNumber" [disabled]="true" />
    </mat-form-field>
    <mat-form-field  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <mat-label>Description </mat-label>
      <input matInput [(ngModel)]="data.ItemDescription" [disabled]="true"/>
    </mat-form-field>
    <mat-form-field  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <mat-label>Lot# </mat-label>
      <input matInput [(ngModel)]="data.LotNumber" />
    </mat-form-field>
    <mat-form-field  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <mat-label>Quantity </mat-label>
      <input matInput [(ngModel)]="data.StatedQuantity" />
    </mat-form-field>
    <mat-form-field  appearance="fill"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty">
      <mat-label>Search Location</mat-label>
      <input matInput (keyup)="applyFilterLocation($event)" #input />
     
      <mat-hint>Filter Location</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="fill"  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>Select location</mat-label>
      <mat-select [(ngModel)]="data.LocationID"  #locations>
        <mat-option *ngFor="let item of ArrayLocations" [value]="item.id">Location: {{ item.location }} - Description: {{ item.locationDescription }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <p>{{ textoResultado }}</p>
  </div>
</div>
<div mat-dialog-actions class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <button
        mat-raised-button
        color="danger"
        (click)="onNoClick()"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
      >
        Close
      </button>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <button
        mat-raised-button
        color="primary"
        (click)="Oneditar(data)"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
      >
        Save
      </button>
    </div>
  </div>
</div>
